import { Action, createAction, props } from '@ngrx/store';
import { label } from '../../util';
import { IKoddiAdsData, IKoddiAdsError, ILoadKoddiAdsParams } from '../../models/cobrand-model';

export const KoddiAdsActionTypes = {
	LOAD_KODDI_ADS: label('[KODDI_ADS] Load Koddi Ads'),
	LOAD_KODDI_ADS_SUCCESS: label('[KODDI_ADS] Load Koddi Ads Success'),
	LOAD_KODDI_ADS_FAILURE: label('[KODDI_ADS] Load Koddi Ads Failure'),
	CLEAR_KODDI_ADS: label('[KODDI_ADS] Clear Koddi Ads'),
};

export interface LoadKoddiAdsPayload extends Required<Pick<ILoadKoddiAdsParams, 'pageId' | 'sessionCookie'>> {}

export class LoadKoddiAds implements Action {
	type = KoddiAdsActionTypes.LOAD_KODDI_ADS;
	constructor(public payload: LoadKoddiAdsPayload) { }
}

export class LoadKoddiAdsSuccess implements Action {
	type = KoddiAdsActionTypes.LOAD_KODDI_ADS_SUCCESS;
	constructor(public payload: { pageId: string; data: IKoddiAdsData[] | null }) { }
}

export class LoadKoddiAdsFailure implements Action {
	type = KoddiAdsActionTypes.LOAD_KODDI_ADS_FAILURE;
	constructor(public payload: { pageId: string; error: IKoddiAdsError | null; errorCode?: string; traceId?: string }) { }
}

export class ClearKoddiAds implements Action {
	type = KoddiAdsActionTypes.CLEAR_KODDI_ADS;
}

export type KoddiAdsActions =
	| LoadKoddiAds
	| LoadKoddiAdsSuccess
	| LoadKoddiAdsFailure
	| ClearKoddiAds;

// Creator actions
export const loadKoddiAds = createAction(
  KoddiAdsActionTypes.LOAD_KODDI_ADS,
  props<{ payload: LoadKoddiAdsPayload }>()
);

export const loadKoddiAdsSuccess = createAction(
  KoddiAdsActionTypes.LOAD_KODDI_ADS_SUCCESS,
  props<{ payload: { pageId: string; data: IKoddiAdsData[] | null } }>()
);

export const loadKoddiAdsFailure = createAction(
  KoddiAdsActionTypes.LOAD_KODDI_ADS_FAILURE,
  props<{ payload: { pageId: string; error: IKoddiAdsError | null; errorCode?: string; traceId?: string } }>()
);

export const clearKoddiAds = createAction(KoddiAdsActionTypes.CLEAR_KODDI_ADS);
